@for(chip of chips(); track $index){
		<mat-chip class="overview-header__chip--table" (click)="openMenu()">
					<span>{{chip.displayName }}</span>
		</mat-chip>
}